import { RouteRecordNormalized } from 'vue-router'

import {
  emptyLayoutRoutes,
  LOGIN_PAGE_NAME,
  profileLayoutRoutes,
  RoutePageLayouts,
} from '@/types/plugins/layout'

export default defineNuxtPlugin((nuxtApp) => {
  const routes = nuxtApp.vueApp.$nuxt.$router.getRoutes()

  setRoutesLayouts(routes)
})

/*
 * Определяем layout для route
 */
const setRoutesLayouts = (routes: RouteRecordNormalized[]) => {
  const { isDesktop } = useDevice()

  return routes.filter((route) => {
    if (route.name) {
      // Для мобильной авторизации используется пустой layout
      const { isMobile } = useDevice()

      if (route.name === 'game-runner') {
        if (isMobile) {
          route.meta.layout = RoutePageLayouts.empty
          return route
        }
      }

      if (route.name === LOGIN_PAGE_NAME && isMobile) {
        emptyLayoutRoutes.push(LOGIN_PAGE_NAME)
      }

      if (profileLayoutRoutes.includes(route.name)) {
        route.meta.layout = isDesktop
          ? RoutePageLayouts.profileDesktop
          : RoutePageLayouts.mobile
      } else if (emptyLayoutRoutes.includes(route.name)) {
        route.meta.layout = RoutePageLayouts.empty
      } else {
        route.meta.layout = isDesktop
          ? RoutePageLayouts.default
          : RoutePageLayouts.mobile
      }
    }

    return route
  })
}
